import { Component, Input, NgZone, ChangeDetectorRef, ElementRef, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { EnpsControl } from '@common/controls/enps-control/enps-control';
import { TimeoutQueue } from '@common/services/timeout-queue';
import { AppService } from '@suite/app.service';

import { GlobalTablesService } from '@common/services/global-tables-service';
import { NomWebServicesJson } from '@common/services/nom-web-services-json';
import { LanguageSettings } from '@common/services/language-settings';
import { AssignmentRecord } from '@playbook/data-models/records/assignment-record';
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
    selector: 'assignment-type',
    templateUrl: './assignment-type.html',
    styleUrls: ['./assignment-type.scss'],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'assignment-type'
    }
})

export class AssignmentType extends EnpsControl<string> {

    @Input() 
    record: AssignmentRecord;


    @Input()
    get showLabel() {
        return this._showLabel;
    }
    set showLabel(value: BooleanInput) {
        this._showLabel = coerceBooleanProperty(value);
    }
    private _showLabel = false;

    @Input()
    get mediumIcon() {
        return this._mediumIcon;
    }
    set mediumIcon(value: BooleanInput) {
        this._mediumIcon = coerceBooleanProperty(value);
    }
    private _mediumIcon = false;

    constructor(
        public appService: AppService,
        ngZone: NgZone,
        changeDetectorRef: ChangeDetectorRef,
        timeoutQueue: TimeoutQueue,
        globalTablesService: GlobalTablesService,
        nomWebServicesJson: NomWebServicesJson,
        public languageSettings: LanguageSettings,
        elementRef: ElementRef
    ) {
        super(appService, ngZone, changeDetectorRef, timeoutQueue, globalTablesService, elementRef);
    }

    get assignmentTypes(): { id: string, title: string }[] {
        return this.globalTablesService.getListItemsForField(this.appService.PSTFieldNames.PSTAssignmentCoverageType)
    }

    get selectedTypeLabel(): string {
        return this.assignmentTypes.find((item) => item.id == this.value)?.title;
    }

    get selectedType(): string {
        return this.value;
    }

    get isDisabled(): boolean {
        if (this.record?.path?.isWasteBinPath || this.record?.parentRecord?.path?.isWasteBinPath) {
            return true;
        }
        return false;
    }

    select(value: string) {
        this.value = value;
        this.changed.next(this.value);
    }
}
